import React from "react";

const Explore = () => {
  return (
    <div
      className="container-fluid explore py-5 wow zoomIn"
      data-wow-delay="0.2s"
    >
      <div className="container py-5 text-center">
        <h1 className="display-1 text-white mb-4">Influencer Metrics</h1>
        <div className="row justify-content-center">
          <div className="col-md-3 col-sm-6 mb-4">
            <div className="d-flex flex-column align-items-center">
              <i className="fas fa-eye fa-3x text-primary mb-2"></i>
              <h5 className="text-white">Average Views</h5>
              <p className="text-white">100,000+</p>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-4">
            <div className="d-flex flex-column align-items-center">
              <i className="fas fa-comments fa-3x text-primary mb-2"></i>
              <h5 className="text-white">Average Engagement</h5>
              <p className="text-white">10,000+</p>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-4">
            <div className="d-flex flex-column align-items-center">
              <i className="fas fa-chart-line fa-3x text-primary mb-2"></i>
              <h5 className="text-white">Follower Growth</h5>
              <p className="text-white">+5% Monthly</p>
            </div>
          </div>
          <div className="col-md-3 col-sm-6 mb-4">
            <div className="d-flex flex-column align-items-center">
              <i className="fas fa-signal fa-3x text-primary mb-2"></i>
              <h5 className="text-white">Impressions/Reach</h5>
              <p className="text-white">500,000+</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Explore;